import React from "react";
const SelectField = ({
  label,
  options,
  name,
  size,
  placeholder,
  required,
  value,
  onChange,
  switchOptions,
  disabled,
  icon,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange("select", name, value); // Call the parent's update function
  };

  return (
    <div className={"col-lg-" + size}>
      <div className="form-group mt-2">
        <label for="name" className="col-sm-12">
          <i className={icon} style={{ fontSize: "20px" }}/><i/> {label}:
          {/* Page Layout */}
        </label>
        <div className="col-sm-12">
          <select
            className="form-select"
            required={required}
            name={name}
            value={value}
            disabled={disabled}
            onChange={handleChange}
          >
            <option value="">{placeholder}</option>
            {options.map((option, index) =>
              (switchOptions === 1) ? (
                
                  <option key={index} value={option.values}>
                    {option.item}
                  </option>
                
              ) : (
               
                  <option key={index} value={option}>
                    {option}
                  </option>
               
              )
            )}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SelectField;
